import React from "react";
import { ITooltipProps } from "./interface";
import { Tooltip } from "antd";
import "./index.less";

const ZTooltip: React.FC<ITooltipProps> = props => {
	const {
		showtooltip = true,
		theme = "dark",
		placement = "right",
		children,
		className = "",
		...rest
	} = props;
	return showtooltip ? (
		<Tooltip
			overlayClassName={`z-tooltip ${
				theme === "dark" ? "" : "z-tooltip-light"
			} ${className}`}
			placement={placement}
			{...rest}
		>
			{children}
		</Tooltip>
	) : (
		<>{children}</>
	);
};

export default ZTooltip;
